module.exports = __webpack_public_path__ + "static/img/bg_jp.a59cf06.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bts-2026-sale/bg_jp.png
// module id = YmyC
// module chunks = 2